import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface MoleculeLotFieldBannersProps {
  /** Whether the molecule lot SSI checkbox is checked. */
  isMoleculeLotSelected: boolean;
  /** Whether this is a new schema being created (not editing an existing one). */
  isCreating: boolean;
}

/**
 * Renders contextual banners for the Molecule Lot schema configuration flow.
 *
 * Prompts the user to configure units on the concentration fields after checking
 * the "Configure as a molecule lot" checkbox.
 */
export default function MoleculeLotFieldBanners({
  isMoleculeLotSelected,
  isCreating,
}: MoleculeLotFieldBannersProps): JSX.Element | null {
  if (!isCreating || !isMoleculeLotSelected) {
    return null;
  }

  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text={
        'Molecule lot fields have been added. Please configure units on the concentration fields: ' +
        'select a molar concentration unit (e.g. M, mM) for "Concentration (molar)" and a ' +
        'mass concentration unit (e.g. g/L, mg/mL) for "Concentration (density)". ' +
        'You can also set a percent unit on the "Purity" field. ' +
        'Use the advanced settings (gear icon) on each field to set the unit.'
      }
    />
  );
}
